import React from 'react';
import { Tag } from 'antd';
import { ClientStatus } from 'api/adminApiClient';
import { getClientStatusName } from 'utils/recruiterUtils';

import styles from './ClientStatusLabel.module.less';

type Props = {
  clientStatus?: ClientStatus;
};

export default function ClientStatusLabel(props: Props) {
  const { clientStatus } = props;
  const clientStatusName = getClientStatusName(clientStatus);

  return (
    <Tag className={styles.clientStatusLabel}>
      Status: <b>{clientStatusName}</b>
    </Tag>
  );
}
